<template>
  <section class="contact_brick" id="contact">
		<div class="container mt-100">
			<div class="row center">
				<div class="col-md-8 col-md-offset-2 col-sm-12">
					<div class="section-title">
						<h2 class="mb-50">LETS WORK TOGETHER</h2>
						<p style="color: black;" class="module-subtitle">I'm always looking for opportunities to work with those who are willing to share their knowledge as much as I want to learn.</p>
					</div>
				</div>
			</div>
            <div class="row mt-100">
                    <!--location-->
                    <div class="col-md-4 col-sm-4 text-center wow slideInLeft">
                        <div class="detail">
                            <i class="lnr lnr-map-marker"></i>
                            <h4><span>You can find me at</span></h4>
                            <h3>My Location</h3>
                                <p>
                                    Tampa, FL 
                                </p>
                        </div>
                    </div>
                    <!--end location-->

                    <!--contact info-->
                    <div class="col-md-4 col-sm-4 text-center wow slideInUp">
                        <div class="detail">
                            <i class="lnr lnr-envelope"></i>
                            <h4><span>My email</span></h4>
                            <h3>Contact</h3>
                            <p>
                                <abbr title="Email">E:</abbr> malaika787@me.com
                                <br>
                                
                            </p>
                        </div>
                    </div>
                    <!--end contact info-->

                    <!--contact info-->
                    <div class="col-md-4 col-sm-4 text-center wow slideInRight">
                        <div class="detail">
                            <i class="lnr lnr-clock"></i>
                            <h4><span>I work on the following</span></h4>
                            <h3>Schedule</h3>
                            <p>
                                M-F: 8 AM - 4 PM<br>
                                Sa: 8 AM - 12 PM<br>
                                Su: Closed
                            </p>
                        </div>
                    </div>
                    <!--end contact info-->
                </div>
            <!-- CONTACT FORM -->
            <div class="contact-form bottom">
                <form id="main-contact-form" name="contact-form" method="post" action="sendemail.php">
                <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <input type="text" name="name" id="name" class="form-control" required="required" placeholder="Name">
                    </div>
                    <div class="form-group">
                        <input type="text" name="company" id="company" class="form-control" required="required" placeholder="Company">
                    </div>
                    <div class="form-group">
                        <input type="email" name="email" id="email" class="form-control" required="required" placeholder="Email Id">
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <textarea name="message" id="message" required="required" class="form-control" rows="8" placeholder="Your text here"></textarea>
                    </div>
                    <div class="form-group">
                        <button id="submit_btn" class="default-btn gray-btn"> Send <i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                    </div>
                </div>
                </form>
            </div>
		</div><!-- end container -->
	</section>

</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      msg: ""
    };
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Contact.vue